import { render } from "./WithholdingAgentSelect.vue?vue&type=template&id=7e6600c8"
import script from "./WithholdingAgentSelect.vue?vue&type=script&lang=js"
export * from "./WithholdingAgentSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__